// extracted by mini-css-extract-plugin
export default {"list":"burger-ingredients_list__GD3c4","list__scroll":"burger-ingredients_list__scroll__th6ab"};